/**
 * MentionsLegales - Page des mentions légales
 * Contenu placeholder à valider par un juriste
 */
import LegalPageLayout from '../components/legal/LegalPageLayout'

export default function MentionsLegales() {
  return (
    <LegalPageLayout
      title="Mentions légales"
      lastUpdate="[DATE À DÉFINIR]"
    >
      {/* Section 1 - Éditeur */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          1. Éditeur du site
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <ul className="list-none space-y-2 text-gray-700">
          <li><strong>Raison sociale :</strong> [À COMPLÉTER]</li>
          <li><strong>Forme juridique :</strong> [À COMPLÉTER]</li>
          <li><strong>Capital social :</strong> [À COMPLÉTER]</li>
          <li><strong>Siège social :</strong> [À COMPLÉTER]</li>
          <li><strong>RCS :</strong> [À COMPLÉTER]</li>
          <li><strong>SIRET :</strong> [À COMPLÉTER]</li>
          <li><strong>N° TVA intracommunautaire :</strong> [À COMPLÉTER]</li>
          <li><strong>Directeur de la publication :</strong> [À COMPLÉTER]</li>
          <li><strong>Contact :</strong> [À COMPLÉTER]</li>
        </ul>
      </section>

      {/* Section 2 - Hébergeur */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          2. Hébergement
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <ul className="list-none space-y-2 text-gray-700">
          <li><strong>Hébergeur :</strong> [À COMPLÉTER]</li>
          <li><strong>Adresse :</strong> [À COMPLÉTER]</li>
          <li><strong>Contact :</strong> [À COMPLÉTER]</li>
        </ul>
      </section>

      {/* Section 3 - Propriété intellectuelle */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          3. Propriété intellectuelle
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <p className="text-gray-600">
          La plateforme RISK-DATA, son interface, son code et sa structure sont
          la propriété exclusive de [À COMPLÉTER]. Toute reproduction,
          extraction ou réutilisation non autorisée est interdite.
        </p>
        <p className="text-gray-600 mt-4">
          Les données toxicologiques sont la propriété des organismes émetteurs
          (INRS, ANSES, ECHA, AGRITOX). RISK-DATA ne revendique aucun droit de
          propriété sur ces données sources.
        </p>
      </section>

      {/* Section 4 - Sources de données */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          4. Sources de données
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <p className="text-gray-600">
          RISK-DATA agrège des données provenant de sources officielles :
        </p>
        <ul className="list-disc list-inside space-y-1 text-gray-600 mt-2">
          <li>INRS (Institut National de Recherche et de Sécurité)</li>
          <li>ANSES (Agence nationale de sécurité sanitaire)</li>
          <li>ECHA (Agence européenne des produits chimiques)</li>
          <li>AGRITOX (Base de données sur les substances actives phytopharmaceutiques)</li>
        </ul>
      </section>

      {/* Section 5 - Limitation de responsabilité */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          5. Limitation de responsabilité
        </h2>
        <p className="text-gray-600">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
      </section>

      {/* Section 6 - Droit applicable */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          6. Droit applicable
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <p className="text-gray-600">
          Le présent site et ses mentions légales sont soumis au droit français.
          Tout litige relatif à l'utilisation du site sera de la compétence
          exclusive des tribunaux de [À COMPLÉTER].
        </p>
      </section>
    </LegalPageLayout>
  )
}
